// frontend/src/api/referrals.js
import { apiClient } from './index';

const referralsApi = {
  // --- USER METHODS ---
  
  getMyCode: async () => {
    return await apiClient.get('/referrals/my-code');
  },

  getMyStats: async () => {
    return await apiClient.get('/referrals/my-stats');
  },

  updateStatus: async (requestId, status) => {
    // status: 'accepted' or 'rejected'
    return await apiClient.put(`/referrals/${requestId}/status`, { status });
  },

  // Admin methods
  // (Add admin methods here if needed later)
};

export { referralsApi };